import {put, takeEvery, call} from 'redux-saga/effects';
import {
    GET_PERIODS_ACTION_REQUEST,
    GET_PERIODS_ACTION_SUCCESS,
    GET_PERIODS_ACTION_FAILURE,
    GET_PERIODS_ACTION_FETCH
} from '../constants';

import Api, {ApiMethods} from 'feedback-system/middleware/api';

import {
    GetPeriodsActionRequest,
    GetPeriodsActionSuccess,
    GetPeriodsActionFailure
} from '../typedef';

type IActions = GetPeriodsActionRequest & GetPeriodsActionSuccess & GetPeriodsActionFailure;

function* getPeriodsData(action: IActions) {
    try {

        yield put({type: GET_PERIODS_ACTION_REQUEST});

        const dataPeriods = yield call(Api.fetch, {
            endpoint: 'periods',
            method: ApiMethods.GET
        });

        const dataPeriod = yield call(Api.fetch, {
            endpoint: 'periods/current',
            method: ApiMethods.GET
        });

        yield put({
            type: GET_PERIODS_ACTION_SUCCESS,
            list: dataPeriods.responseData,
            current: dataPeriod.responseData
        });
    } catch (e) {
        yield put({type: GET_PERIODS_ACTION_FAILURE, error: e});
    }
}

function* getPeriodsSaga() {
    yield takeEvery(GET_PERIODS_ACTION_FETCH, getPeriodsData);
}

export {
    getPeriodsSaga
};
